import React from "react";
import { Link } from "react-router-dom";
import { Badge, Card, CardBody, Col, Container, Row } from "reactstrap";
import { clearApiErrorState, getApiErrorState } from "../../helpers/apiErrorState";

const ERROR_CONTENT = {
  401: {
    title: "Unauthorized",
    heading: "Your session is no longer valid.",
    description: "Authentication is required before this resource can be accessed.",
  },
  404: {
    title: "Not Found",
    heading: "The requested resource could not be found.",
    description: "The item you are trying to access does not exist or is no longer available.",
  },
  403: {
    title: "Forbidden",
    heading: "You do not have permission to access this resource.",
    description: "Your account is authenticated, but it is not allowed to perform this action.",
  },
  default: {
    title: "Server Error",
    heading: "The server could not complete the request.",
    description: "An unexpected server-side error occurred. Please try again later.",
  },
};

const ApiErrorPage = () => {
  const errorState = getApiErrorState() || {};
  const status = Number(errorState.status || 500);
  const message = errorState.message || "";

  const content =
    status === 401
      ? ERROR_CONTENT[401]
      : status === 404
        ? ERROR_CONTENT[404]
      : status === 403
        ? ERROR_CONTENT[403]
        : ERROR_CONTENT.default;

  const handleGoToLogin = () => {
    clearApiErrorState();
    localStorage.removeItem("access_token");
    localStorage.removeItem("authUser");
  };

  const handleBackToHome = () => {
    clearApiErrorState();
    if (status === 401) {
      handleGoToLogin();
    }
  };

  document.title = `${status} ${content.title} | Valitan IMS`;

  return (
    <div className="my-5 pt-5">
      <Container>
        <Row className="justify-content-center">
          <Col xl={7} lg={8}>
            <Card className="border-0 shadow-sm">
              <CardBody className="p-4 p-md-5 text-center">
                <Badge color={status >= 500 ? "danger" : status === 403 ? "warning" : "secondary"} pill className="mb-3">
                  HTTP {status}
                </Badge>

                <h1 className="display-4 fw-bold mb-2">{status}</h1>
                <h3 className="mb-3">{content.heading}</h3>
                <p className="text-muted mb-4">{message || content.description}</p>

                <div className="d-flex justify-content-center">
                  <Link
                    to={status === 401 ? "/login" : "/"}
                    className="btn btn-primary"
                    onClick={handleBackToHome}
                  >
                    Back to Home
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ApiErrorPage;
